module.exports = __webpack_public_path__ + "static/media/pic3.4ff60f51.jpg";